var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.code)?_c('div',{class:_vm.defaultClasses,domProps:{"innerHTML":_vm._s(_vm.code)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }